import { useAppContext } from '../../../../app/Context';
import { useTimerContext } from './Context';

const useTimerPage = () => {
  const { isPresenting } = useAppContext();

  const { backgroundImage } = useTimerContext();
  const hasBackgroundImage = Boolean(backgroundImage);

  const isTimerCardCentered = isPresenting && !hasBackgroundImage;

  return { isTimerCardCentered };
};

export default useTimerPage;
